import { FETCH_ALL_ORG_URI } from "src/shared/config";
import { ApiResponse } from "src/shared/types";
import appFetch from "src/shared/fetch";
import { getXClientIdHeader } from "src/utils/getservicename";

type GetAllOrgParams = {
  timeTab: string;
  shouldFetchFreshData?: boolean;
};

export const getAllOrgs = ({ shouldFetchFreshData, timeTab }: GetAllOrgParams): ApiResponse =>
  appFetch.get(FETCH_ALL_ORG_URI, {
    params: { isFetchMain: "true", timeTab: timeTab },
    headers: shouldFetchFreshData ? { "X-Clear-Cache": "true", ...getXClientIdHeader() } : getXClientIdHeader(),
  });
